import { createEvent, createStore, sample } from "effector";
import { ModelContract, ModuleDescription } from "@features/shared/module-description";
import { INotification } from "@features/shared/entities/notification";
import { delay } from "patronum";
import { IAppRouteUnitsContract } from "@features/app/route-units";

export const toastShow = createEvent<INotification>();
const toastHidden = createEvent();
const timeoutChanged = createEvent<number>();

const $messageText = createStore<INotification | null>(null)
    .on(toastShow, (_, payload) => {
        return payload ?? null;
    })
    .reset(toastHidden);
const $timeout = createStore(20 * 1000).on(timeoutChanged, (_, payload) => payload);

delay({
    source: toastShow,
    timeout: $timeout,
    target: toastHidden
});

const contract = new ModelContract(
    {
        $messageText
    },
    {
        toastShow,
        toastHidden
    },
    {},
    {}
);

export type INotificationContract = typeof contract;

export class NotificationModule extends ModuleDescription<INotificationContract> {
    constructor(
        public routesModule: IAppRouteUnitsContract
    ) {
        super();
    }
    getDefaultContract() {
        return contract;
    }

    run() {
        sample({
            source: this.routesModule.stores.assistant.$isActive,
            filter: (s) => s,
            fn: () => 3 * 1000,
            target: timeoutChanged
        });
    }
}
